enum CardRole {
    /**
     *  The card has one address to show
     */
    Primary,

    /**
     *  The card has combined address
     */
    Combined,
}

export default CardRole;
